import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { isArray, isEmpty } from 'lodash'
import media from '../assets/styles/media'

import Nav from './nav'
import { AppContext } from '../context/app'
import useRoute from '../hooks/useRoute'
import useIntercom from '../hooks/useIntercom'
import useNavigation from '../hooks/useNavigation'
import Preloader from './common/preloader'
import LicensesForm from './licenses'

const Row = styled.div`
  display: flex;
  min-height: 100vh;
`

const Main = styled.main`
  display: flex;
  flex-direction: column;
  width: calc(100% - 200px);

  ${media.lg`
    ${({ row }) =>
      row &&
      `
      flex-direction: row;
      align-items: center;
    `}
  `}
`

const Layout = ({ children, withNav, row }) => {
  const {
    user,
    licenses,
    sessionId,
    startSession,
    operatingStates
  } = useContext(AppContext)
  const navigate = useNavigation()
  const url = useRoute()
  useIntercom(process.env.INTERCOM_APP_ID)

  useEffect(() => {
    const auth = async () => {
      if (!sessionId && !(url && url.includes('login'))) {
        const session = await startSession()
        if (!session) navigate('/login')
      }
    }
    auth()
  })

  const licensesPrompt =
    (isArray(licenses) &&
      isArray(operatingStates) &&
      licenses.length !== operatingStates.length) ||
    (isArray(operatingStates) && isEmpty(licenses)) ||
    !licenses
  return (
    <Row>
      {withNav && <Nav />}
      <Main row={row}>
        {user || (url && url.includes('login')) ? children : <Preloader />}
        {licensesPrompt && <LicensesForm />}
      </Main>
    </Row>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired
}

export default Layout
